/* ============================================
   MENTEX SCROLL ANIMATIONS
   Intersection Observer-based reveal animations
   ============================================ */

(function() {
  'use strict';

  // Respect reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mtx-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  // Auto-observe elements with animation classes
  function initAnimations() {
    var animatedElements = document.querySelectorAll(
      '.mtx-animate, .mtx-fade-in, .mtx-scale-in'
    );
    animatedElements.forEach(function(el) {
      observer.observe(el);
    });

    // Auto-apply animations to common section elements
    var sections = document.querySelectorAll(
      '.shopify-section .section-heading,' +
      '.shopify-section .grid__item,' +
      '.shopify-section .swiper-slide'
    );
    sections.forEach(function(el) {
      if (!el.classList.contains('mtx-animate') &&
          !el.classList.contains('mtx-fade-in') &&
          !el.classList.contains('mtx-scale-in')) {
        el.classList.add('mtx-animate');
        observer.observe(el);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();
